export enum ReportTag {
  COMPANY_NAME = '#COMPANY_NAME',
  SIRET = '#SIRET',
  UNIVERS_METIER = '#UNIVERS_METIER',
}
